import { deepEqual } from '@util-lib/deepEqual'

export const deepEqualAny = (x: unknown, y: unknown) =>
    x === y ||
    (typeof x === 'object' && typeof y === 'object' && deepEqual(x, y))
